module.exports = __webpack_public_path__ + "static/media/tree.8b5c41e6.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/page_app_solution/tree.png
// module id = 525
// module chunks = 0